<template>
  <div id="QuizFeature">
    <div class="site_header">
      <h1>Quiz Feature</h1>
      <h5>Test Your APWH Knowledge</h5>
    </div>

    <b-container fluid class="quiz-layout pt-4 pt-md-5">
      <b-row>
        <b-col
          v-for="(section, sectionIndex) in unitSections"
          :key="sectionIndex"
          cols="12"
          sm="6"
          lg="3"
          class="section-column"
        >
          <h2 class="section-title">{{ section.title }}</h2>

          <div class="section-cards">
            <div
              v-for="(card, cardIndex) in section.cards"
              :key="cardIndex"
              class="unit-card"
              :class="{
                'unit-card--active': isActiveUnit(card),
                'unit-card--disabled': !isActiveUnit(card)
              }"
              :role="isActiveUnit(card) ? 'button' : null"
              :tabindex="isActiveUnit(card) ? 0 : -1"
              @click="onCardClick(card)"
              @keydown.enter="onCardClick(card)"
              @keydown.space.prevent="onCardClick(card)"
            >
              <img :src="card.image" :alt="`${card.title} image`" />
              <div class="overlay">
                <span v-if="!isActiveUnit(card)" class="status-pill">Locked</span>
                <h3 class="unit-title">{{ card.title }}</h3>
                <p class="unit-description">{{ card.description }}</p>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import storequiz from "@/store/quiz.js";
import { pushRoute } from "@/router/navigation";
import { trackEvent } from "@/services/analyticsService";
export default {
  name: "CardContainer",
  computed: {
    unitSections() {
      return storequiz.state.sections;
    }
  },
  methods: {
    isActiveUnit(card) {
      return card.title === "Unit 1";
    },
    onCardClick(card) {
      if (this.isActiveUnit(card)) {
        trackEvent("quiz_started", {
          quiz_title: card.title,
          quiz_unit: card.title
        });
        this.goto();
      }
    },
    goto() {
      pushRoute("QuizUnit1");
    }
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    trackEvent("quiz_catalog_viewed");
  }
};
</script>

<style lang="sass" scoped src="@/assets/css/quiz.sass"></style>
